import Table from "../../../components/Table/Table";
import {
  PaginationContainer,
  Header,
  ReviewActionBar,
  ReviewActionButton,
  AcknowledgedLabel,
} from "../HomeStyled";
import Pagination from "../../../components/Pagination/Pagination";
import {
  fileNameColumn,
  matterColumn,
  renderText,
  renderVeteransAffairsStatus,
  sortableTitle,
} from "../../../utils/columns";
import PropTypes from "prop-types";
import { commonProps, veteransAffairsItemShape } from "../Proptypes/Proptypes";
import MatterLoader from "../../../components/Loader/MatterLoader";

const formatSentAt = (value) =>
  value
    ? new Date(value).toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "-";

const VeteransAffairsTab = ({
  veteransAffairsList,
  currentPage = 1,
  handlePageChange,
  onSort,
  getRowProps,
  filterState,
  handleChangePageSize,
  isLoading = false,
  isInitialLoad = false,
  onAcknowledgeError,
  acknowledgingId = null,
}) => {
  const { veteransAffairs } = filterState;
  const search = "search logic has to be added here";
  const columns = [
    fileNameColumn(search, onSort),
    { ...matterColumn, title: sortableTitle("MATTER", "matter_name", onSort) },
    {
      title: <Header>FILED WITH</Header>,
      dataIndex: "filed_with_label",
      key: "filed_with_label",
      render: (text, record) => (
        <span>
          {text || "-"}
          {record?.copy_note && (
            <>
              <br />
              <small>{record.copy_note}</small>
            </>
          )}
        </span>
      ),
    },
    {
      title: sortableTitle("SENT AT", "sent_on", onSort),
      dataIndex: "sent_on",
      key: "sent_on",
      render: formatSentAt,
    },
    {
      title: sortableTitle("SENT BY", "sent_by", onSort),
      dataIndex: "sent_by",
      key: "sent_by",
      render: renderText,
    },
    {
      title: sortableTitle("STATUS", "status", onSort),
      dataIndex: "status",
      key: "status",
      render: (text) => {
        return renderVeteransAffairsStatus(text, "veteransAffairs");
      },
    },
    {
      title: <Header>ACTIONS</Header>,
      dataIndex: "",
      key: "actions",
      render: (_, record) => {
        if (record.error_acknowledged_at) {
          return <AcknowledgedLabel>Acknowledged</AcknowledgedLabel>;
        }
        if (record.status !== "error" || !onAcknowledgeError) {
          return null;
        }
        return (
          <ReviewActionBar>
            <ReviewActionButton
              type="button"
              disabled={acknowledgingId === record.id}
              onClick={(event) => {
                event.stopPropagation();
                onAcknowledgeError(record);
              }}
            >
              Acknowledge
            </ReviewActionButton>
          </ReviewActionBar>
        );
      },
    },
  ];

  return (
    <div style={{ position: 'relative', minHeight: '400px' }}>
      {isLoading && !isInitialLoad && (
        <MatterLoader message="Loading..." offsetTop={0} absolute={true} />
      )}
      {(!isLoading || isInitialLoad) && (
        <>
          <Table
            columns={columns}
            data={veteransAffairsList?.results || []}
            onRow={getRowProps}
            emptyMessage={"No records found"}
          />
          {veteransAffairsList?.results?.length > 0 && (
            <PaginationContainer>
              <Pagination
                total={veteransAffairsList.count}
                current={currentPage}
                pageSize={veteransAffairs?.page_size}
                onChange={(page) =>
                  handlePageChange({ label: "page", value: page })
                }
                adjustable={false}
                onPageSizeChange={handleChangePageSize}
              />
            </PaginationContainer>
          )}
        </>
      )}
    </div>
  );
};

VeteransAffairsTab.propTypes = {
  veteransAffairsList: PropTypes.shape({
    results: PropTypes.arrayOf(veteransAffairsItemShape),
    count: PropTypes.number,
  }),
  ...commonProps,
  currentPage: PropTypes.number,
  onAcknowledgeError: PropTypes.func,
  acknowledgingId: PropTypes.number,
};
VeteransAffairsTab.defaultProps = {
  currentPage: 1,
};

export default VeteransAffairsTab;
